import type { CategoriesResponse } from '../types';

export async function fetchCategories(): Promise<CategoriesResponse> {
  const res = await fetch('/api/categories');
  if (!res.ok) throw new Error(`API ${res.status}`);
  return (await res.json()) as CategoriesResponse;
}
